import { pick } from 'lodash'
import Vue from 'vue'
import i18n from './vendor/i18n'
import countries from 'i18n-iso-countries'
import languages from '@cospired/i18n-iso-languages'

const debug = false

export default ({ appCache, moment, vuetify, cookie, translations }) => {
  for (const translation of translations) {
    countries.registerLocale(require('i18n-iso-countries/langs/' + translation + '.json'))
    languages.registerLocale(require('@cospired/i18n-iso-languages/langs/' + translation + '.json'))
  }

  return Vue.prototype.$locale = new Vue({
    data () {
      return {
        countries: appCache.entities.countries,
        languages: appCache.entities.languages,
        defaultLanguageCountry: appCache.entities.default_language_country,
        translations,
        i18n
      }
    },
    computed: {
      countriesItems () {
        return this.countries.map(value => {
          return { value, text: this.countryCodeToName(value) }
        })
      },
      languagesItems () {
        return this.languages.map(value => {
          return { value, text: this.languageCodeToName(value) + ' (' + languages.getName(value.toUpperCase(), 'en') + ')' }
        })
      },
      translatedLanguages () {
        return this.translations
      },
      translatedLanguagesItems () {
        return this.languagesItems.filter(item => this.translatedLanguages.includes(item.value))
      },
      timezones () {
        return this.$moment.tz.names()
      },
      timezonesItems () {
        return this.timezones.map(timezone => {
          return {
            text: timezone,
            value: timezone
          }
        })
      }
    },
    methods: {
      setLanguage (name) {
        if (debug) console.log('[locale] Updating interface language, setting "' + name + '" into i18n.locale, moment.locale, vuetify.lang.current.')
        this.i18n.locale = name
        moment.locale(name)
        vuetify.framework.lang.current = name
      },
      setTimezone (name) {
        if (debug) console.log('[locale] Updating interface timezone, setting "' + name + '" into moment.tz.')
        moment.tz.setDefault(name)
      },
      countryCodeToName (code) {
        return countries.getName(code.toUpperCase(), i18n.locale)
      },
      languageCodeToName (code) {
        return languages.getName(code.toUpperCase(), i18n.locale)
      },
      getAllFromBrowser () {
        let language, country

        const languageCookie = cookie.get('language')
        if(languageCookie) {
          if (debug) console.log('[locale] Reading cookie[language] :', languageCookie)
          language = languageCookie
        } else {
          if (debug) console.log('[locale] Reading navigator.language :', navigator.language)
          const splitted = navigator.language.toLowerCase().split('-')
          if (splitted.length > 1) {
            language = splitted[0] in this.languages ? splitted[0] : 'en'
            country = splitted[1] in this.countries ? splitted[1] : 'us'
          } else {
            language = splitted[0] in this.languages ? splitted[0] : 'en'
          }
        }

        if(!country) {
          country = this.defaultLanguageCountry[language] || 'us'
          if (debug) console.log('[locale] Resolving country from language :', country)
        }

        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

        if (debug) console.log('[locale] - Resolved country ' + country + ', language ' + language + ', timezone ' + timezone)

        return { country, language, timezone }
      }
    }
  })
}